import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    Typography,
} from '@material-ui/core'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import WaterpoolRecordListDialog from './waterpool-record-list-dialog'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'

const initialState = {
    input: {
        id: '',
        balance: 0,
        operator: 'add',
        money: 0,
    },
    dialogOpen: false,
    confirmDisabled: false,
}

class EditWaterPoolBalanceDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditWaterPoolBalanceDialog', options)
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    data

    reset(inputs) {
        this.setState({
            input: {
                ...initialState.input,
                ...inputs,
                game_risk_info_prevention_red_ban_score:
                    this.props.owner.gameRiskInfoList[
                        utils.ComposeGameRiskInfoKey(inputs.oid, RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_RED, inputs.pf_sub_pf_id)
                    ].ban_score,
                game_risk_info_prevention_yellow_ban_score:
                    this.props.owner.gameRiskInfoList[
                        utils.ComposeGameRiskInfoKey(inputs.oid, RISKMGT.RISK_LABEL_WATERPOOL_PREVENTION_YELLOW, inputs.pf_sub_pf_id)
                    ].ban_score,
            },
        })
    }

    OpenDialog(inputs) {
        this.reset(inputs)
        this.setState({ dialogOpen: true, confirmDisabled: false })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>
                    {this.t('title', {
                        game_name: this.t('GameName.' + this.state.input.game_code),
                    })}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={9}>
                            <TextField
                                label={this.t('balance')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.balance}
                                margin="dense"
                                readOnly={true}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <Button variant="contained" onClick={() => this.recordListDialog.OpenDialog(this.state.input.id)} color="primary">
                                {this.t('record')}
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl margin="dense" style={{ marginRight: '5px' }}>
                                <InputLabel htmlFor="age-simple"></InputLabel>
                                <Select
                                    value={this.state.input.operator}
                                    onChange={(event) =>
                                        this.setState({
                                            input: {
                                                ...this.state.input,
                                                operator: event.target.value,
                                            },
                                        })
                                    }>
                                    <MenuItem value={'add'}>{this.t('add')}</MenuItem>
                                    <MenuItem value={'minus'}>{this.t('minus')}</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                label={this.t('money')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.money}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 0 || isNaN(value)) {
                                        value = 0
                                    }

                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            money: value,
                                        },
                                    })
                                }}
                                margin="dense"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography color="error" style={{ whiteSpace: 'pre-line' }}>
                                {this.t('warning')}
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.confirmDialog.OpenDialog({
                                type: 'info',
                                msg: this.t('confirmMsg', {
                                    game_name: this.t('GameName.' + this.state.input.game_code),
                                    operator: this.t(this.state.input.operator),
                                    money: utils.currencyFormatter(this.state.input.money, 0),
                                }),
                                confirm: (_params) => {
                                    this.confirmDialog.SetConfirmBtnDisabled(true)
                                    this.setState({ confirmDisabled: true })

                                    let apiPath

                                    if (this.state.input.operator === 'add') {
                                        apiPath = API.JACKPOT_DEPOSIT
                                    } else if (this.state.input.operator === 'minus') {
                                        apiPath = API.JACKPOT_WITHDRAW
                                    }

                                    utils.apiRequest(
                                        'put',
                                        apiPath,
                                        {
                                            id: this.state.input.id,
                                            money: parseInt(this.state.input.money),
                                        },
                                        (_data) => {
                                            this.confirm()
                                        },
                                        () => {
                                            this.setState({ confirmDisabled: false })
                                        },
                                        true
                                    )
                                },
                            })
                        }}
                        color="primary"
                        disabled={this.state.confirmDisabled}>
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
                <WaterpoolRecordListDialog onRef={(ref) => (this.recordListDialog = ref)} ownerState={this.state}></WaterpoolRecordListDialog>
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        editorToolbar: {
            border: 'solid 1px',
            margin: '12px 0',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        editorWrapper: {},
        editorEditor: {
            height: '300px',
            padding: '0 14px',
            border: 'solid 1px',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
    }
}

EditWaterPoolBalanceDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    owner: PropTypes.object,
}

export default hoc(styles)(EditWaterPoolBalanceDialog)
